import { SxProps, Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const serviceDeskStyles = {
    root: {
        maxWidth: 800,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    } satisfies SxProps<Theme>,
    titleSection: {
        textAlign: 'center',
    } satisfies SxProps<Theme>,
    containerPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    tabs: {
        borderBottom: '1px solid',
        borderColor: 'divider',
    } satisfies SxProps<Theme>,
    tab: {
        textTransform: 'none',
        minHeight: 56,
    } satisfies SxProps<Theme>,
    content: {
        p: 4,
    } satisfies SxProps<Theme>,
    sectionColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    resultsDivider: {
        mb: 3,
    } satisfies SxProps<Theme>,
    resultsListPaper: {
        borderRadius: 2,
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    resultRow: {
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            bgcolor: 'action.hover',
        },
    } satisfies SxProps<Theme>,
    resultRowMain: {
        display: 'flex',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    vehicleIconBox: {
        width: 36,
        height: 36,
        borderRadius: 1,
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    } satisfies SxProps<Theme>,
    customerIconBox: {
        width: 36,
        height: 36,
        borderRadius: '50%',
        bgcolor: 'primary.50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    } satisfies SxProps<Theme>,
    customerMeta: {
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
    } satisfies SxProps<Theme>,
    customerMetaItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    } satisfies SxProps<Theme>,
    customerResultsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
    } satisfies SxProps<Theme>,
};

export const vinInputStyles: CSSProperties = {
    fontFamily: 'monospace',
    textTransform: 'uppercase',
};
